<!-- 专家库-编辑页 -->
<template>
  <div id="edit" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">{{ $route.query.id ? "编辑" : "新建" }}专家</div>
    <!-- 编辑表单 -->
    <div class="edit_form">
      <el-form :model="expertItem" :rules="rules" label-position="top" ref="expertItem" label-width="100px" class="form_salesContract">
        <el-row :gutter="20">
          <!-- 专家姓名 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家姓名" prop="expertName">
              <el-input v-model="expertItem.expertName" placeholder="请输入专家姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 专家性别 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家性别" required>
              <el-radio-group v-model="expertItem.gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- 专家年龄 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家年龄" prop="age">
              <el-input v-model="expertItem.age" type="number" placeholder="请输入专家年龄" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 专家身份证 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家身份证" required>
              <el-input v-model="files_identityCard[0].name" placeholder="请上传专家身份证" disabled>
                <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_identityCard">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 专家工作照 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家工作照" required>
              <el-input v-model="files_workPhoto[0].name" placeholder="请上传专家工作照" disabled>
                <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_workPhoto">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 目前所涉及的行业 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="目前所涉及的行业" required>
              <el-cascader ref="tradeList" v-model="selected_trade" :options="tradeList" :props="props_cascader" clearable @change="handleChange"
                placeholder="请选择目前所涉及的行业" size="small" style="width: 100%;"></el-cascader>
            </el-form-item>
          </el-col>
          <!-- 专家职称级别 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家职称级别" prop="rank">
              <el-select v-model="expertItem.rank" placeholder="请选择专家职称级别" clearable style="width: 100%;">
                <el-option v-for="(opt, o) in rankList" :key="o" :label="opt.name" :value="opt.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 专家所属单位 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家所属单位" prop="affiliatedUnit">
              <el-input v-model="expertItem.affiliatedUnit" placeholder="请输入专家所属单位" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 专家擅长模块 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家擅长模块" prop="adept">
              <el-select v-model="expertItem.adept" placeholder="请选择专家擅长模块" multiple clearable style="width: 100%;">
                <el-option v-for="(opt, o) in modelList" :key="o" :label="opt.name" :value="opt.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 专家用户名/邮箱 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="专家用户名/邮箱" prop="registerMail">
              <el-input v-model="expertItem.registerMail" placeholder="请输入专家用户名/邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 密码 -->
          <el-col v-if="!$route.query.id" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="账户密码" prop="password">
              <el-input v-model="expertItem.password" placeholder="请输入账户密码" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 联系方式 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="联系电话">
              <el-input v-model="expertItem.contactsPhone" placeholder="请输入联系电话" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 电子签名 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="电子签名" required>
              <el-input v-model="files_signature[0].name" placeholder="请上传电子签名" disabled>
                <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_signature">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" @click="submitForm('expertItem')">保存</el-button>
      <el-button plain @click="$router.push('/accountPages/expertManage')">返回</el-button>
    </div>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>
  </div>
</template>
<script>
import cropper from "../../../components/cropper.vue";
export default {
  name: "edit",
  components: { cropper },
  data() {
    return {
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      expertItem: { gender: 1, adept: [], password: '123456' },
      tradeList: [],
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      selected_trade: [],
      rankList: [
        { name: "初级职称", id: 1 }, { name: "中级职称", id: 2 }, { name: "副高级职称", id: 3 }, { name: "正高级职称", id: 4 }
      ],
      modelList: [
        { name: "组织保障", id: 1 }, { name: "三基建设", id: 2 }, { name: "人机精细化管理", id: 3 }, { name: "改善与创新", id: 4 },
      ],
      rules: {
        expertName: [
          { required: true, message: '请输入专家姓名', trigger: 'blur' },
        ],
        age: [
          { required: true, message: '请输入专家年龄', trigger: 'blur' },
        ],
        rank: [
          { required: true, message: '请选择职称级别', trigger: 'blur' },
        ],
        affiliatedUnit: [
          { required: true, message: '请输入所属单位', trigger: 'blur' },
        ],
        adept: [
          { required: true, message: '请选择擅长模块', trigger: 'blur' },
        ],
        registerMail: [
          { required: true, message: '请输入用户名/邮箱', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入账户密码', trigger: 'blur' },
        ],
      },
      // 附件
      files_identityCard: [{ name: '' }],
      files_workPhoto: [{ name: '' }],
      files_signature: [{ name: '' }],
    };
  },
  created() {
    this.getIndustryTypes();
    this.getModuleList();
    if (this.$route.query.id) {//编辑跳转
      this.$set(this.expertItem, "id", this.$route.query.id);
      this.getInfo();
    }
  },
  methods: {
    //获取目前所涉及的行业
    getIndustryTypes() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.tradeList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取所有模块
    getModuleList() {
      this.$axios
        .post(`${process.env.BASE_URL}api/question/getQuestion`)
        .then((res) => {
          if (res.data.code === 200) {
            this.modelList = Object.assign([], res.data.data);
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userInfo`, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 200) {
            this.expertItem = JSON.parse(JSON.stringify(res.data.data));
            // 状态回显赋值
            this.selected_trade = [];
            if (this.expertItem.industryCategory) {
              if (this.expertItem.industryCategory.indexOf(',') > -1) {
                let industryArr = this.expertItem.industryCategory.split(',');
                industryArr.forEach((item) => {
                  this.selected_trade.push(item.split('-'));
                })
              } else {
                this.selected_trade.push(this.expertItem.industryCategory.split('-'));
              }
            }
            if (this.expertItem.adept && this.expertItem.adept) {
              let adeptArr = [];
              this.expertItem.adept.split(',').forEach((selected) => {
                adeptArr.push(Number(selected))
              });
              this.expertItem.adept = adeptArr;
            }
            // 附件回显赋值
            this.setFiles_init();
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChange(val) {
      this.selected_trade = val;
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.selected_trade.length) {
            this.$message.error('请选择目前所涉及的行业')
          } else {
            if (this.files_identityCard[0].url && this.files_workPhoto[0].url && this.files_signature[0].url) {
              let kes_files = ['identityCard', 'workPhoto', 'signature'];
              kes_files.forEach((key, i) => {
                let params = []
                this['files_' + key].forEach((e) => {
                  let file = { name: e.name, url: e.url };
                  params.push(file)
                });
                this.$set(this.expertItem, kes_files[i], JSON.stringify(params))
              });
              // 放置目前所涉及的行业数组
              let industryArr = [];
              this.selected_trade.forEach((arrItem) => {
                industryArr.push(arrItem.join('-'))
              });
              this.$set(this.expertItem, 'industryCategory', industryArr.join(','));
              this.expertItem.adept = this.expertItem.adept.join(',');
              // 新增用户-放置初始密码
              if (!this.$route.query.id) { this.expertItem.password = '123456' }
              this.$axios
                .post(`${process.env.BASE_URL}api/user/registerExpert`, this.expertItem).then(res => {
                  if (res.data.code == 200) {
                    this.$router.push('/accountPages/expertManage')
                  } else {
                    this.expertItem.adept = [];
                    this.selected_trade = [];
                    this.expertItem.industryCategory = '';
                    this.$message({
                      message: res.data.msg,
                      type: "error"
                    });
                  }
                }).catch((err) => {
                  this.expertItem.adept = [];
                  this.selected_trade = [];
                  this.expertItem.industryCategory = '';
                  console.log(err);
                });
            } else {
              this.$message({
                message: '请上传完整证件',
                type: "warning"
              });
            }
          }
        } else {
        }
      })
    },
    // 附件回显赋值
    setFiles_init() {
      let fileKeys = ['identityCard', 'workPhoto', 'signature'];
      fileKeys.forEach((key, i) => {
        if (this.expertItem[key]) {
          let files = JSON.parse(this.expertItem[key]);
          if (files.length) { this['files_' + fileKeys[i]] = JSON.parse(this.expertItem[key]); }
        }
      });
    },
    // 总状态回显赋值
    setStatus_init() {
      let selecKeys = ['industryCategory'];
      selecKeys.forEach((key) => {
        if (this.expertItem[key] != undefined) {
          this.expertItem[key] = Number(this.expertItem[key])
        }
      })
    },
    uploadImg_identityCard(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'identityCard');
    },
    uploadImg_workPhoto(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'workPhoto');
    },
    uploadImg_signature(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'signature');
    },
    // 图标上传回调
    callBack(data) {
      this.$message({ message: `上传成功`, type: "success" });
      if (data.type == 'identityCard') {
        this.files_identityCard = [{ name: data.name, url: data.url }];
        this.$set(this.expertItem, "identityCard", data.name);
      } else if (data.type == 'workPhoto') {
        this.files_workPhoto = [{ name: data.name, url: data.url }];
        this.$set(this.expertItem, "workPhoto", data.name);
      } else {
        this.files_signature = [{ name: data.name, url: data.url }];
        this.$set(this.expertItem, "signature", data.name);
      }
    },
  },
};
</script>
<style lang="less" scoped>
// pc端
.edit_form {
  // margin-bottom: 80px;

  /deep/.el-input,
  /deep/.el-textarea {
    max-width: 500px;
  }

  /deep/.el-select,
  /deep/.el-date-editor {
    width: 300px;
  }
}

.pop_input /deep/.el-input__inner {
  font-size: 14px;
  padding: 0px 5px;
  height: 25px;
}

/deep/.el-popover {
  padding: 20px;
}
.list {
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;

    .el-icon-close {
      font-size: 18px;
      cursor: pointer;
    }

    .col {
      // display: flex;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .proAdd {
    justify-content: center;
    line-height: 18px;
    cursor: pointer;
  }

  .develirymed {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 15px 0;

    p {
      line-height: 15px;
    }
  }
}
/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .edit_form {
    /deep/.el-select,
    /deep/.el-date-editor {
      width: 70%;
    }
  }

  .flexStart {
    /deep/.el-select {
      width: 70%;
    }
  }
}
</style> 